((drupalSettings) => {
  const root = document.querySelector("[data-js-header-menu-desktop]");
  const menuContainer = document.querySelector("[data-js-header-nav]");
  const menuToggle = document.querySelector("[data-js-header-menu-toggle]");
  const menuSettings = drupalSettings.yellowstone.mainMenu;

  const createMenu = (
    container = menuContainer,
    menu = menuSettings,
    count = 0
  ) => {
    if (!menu || !menu.length) return;
    count = count;

    const list = document.createElement("ul");
    if (container === menuContainer) {
      list.classList.add("header__menu");
    } else {
      list.classList.add(`header__submenu-lvl${count}`);
    }
    for (const { title, color, url, is_external, children } of menu) {
      const li = document.createElement("li");
      const link = document.createElement("a");
      li.className = "header__menu__item";
      li.classList.add(`lvl-${count}`);
      link.setAttribute("href", url);
      link.classList.add('header__menu__item__link');
      if (is_external) {
        link.setAttribute("target", "_blank");
      }
      link.textContent = title;
      li.insertAdjacentElement("beforeend", link);
      if (container === menuContainer) {
        li.setAttribute("style", `border-left: 4px solid ${color};`);
        li.setAttribute("data-color", color);
      }
      if (children) {
        li.insertAdjacentHTML('beforeend', `<button class="button-submenu"><span class="sr-only">Afficher le sous-menu ${title}</span></button>`);
        createMenu(li, children, count + 1);
        li.classList.add("expanded");
      }
      list.appendChild(li);
    }

    container.appendChild(list);
  };

  const littleStyle = () => {
    const headerSubmenus = document.querySelectorAll(".header__submenu-lvl1");

    headerSubmenus.forEach((submenu) => {
      let color = submenu.parentNode.dataset.color;
      submenu.setAttribute(
        "style",
        `border-bottom: 4px solid ${color};`
      );

      submenu.querySelectorAll('.header__menu__item a').forEach(linkSubmenu => {
        linkSubmenu.insertAdjacentHTML('afterbegin', `<span class="bulle" aria-hidden="true" style="background-color:${color}"></span>`);
      });
    });
  };

  const toggleMenu = () => {
    menuToggle.classList.toggle('open');
    root.classList.toggle('open');
    if (menuToggle.getAttribute("aria-expanded") === "true") {
      menuToggle.setAttribute("aria-expanded", "false");
      document.querySelector('body').classList.remove('open-menu');
      if(root.querySelector('ul[style]')) {
        root.querySelector('ul[style]').removeAttribute('style');
      }
    } else {
      menuToggle.setAttribute("aria-expanded", "true");
      document.querySelector('body').classList.add('open-menu');
      keyboardNavigation(root.querySelector('.menu-container'));
    }
  };

  const submenuOpen = () => {
    const submenuButtons = document.querySelectorAll('.button-submenu');
    const submenuOpen = root.querySelectorAll('ul.open-submenu');

    submenuButtons.forEach(button => {
      const submenuTitle = button.parentNode.querySelector('.header__menu__item__link').textContent;
      const liTemplate = `<li class="header__menu__item back-link"><button class='back'><span class="back-icon" aria-hidden="true"></span><span class="sr-only">Revenir à</span>${submenuTitle}</button></li>`;
      button.nextSibling.insertAdjacentHTML('afterbegin', liTemplate);

      button.addEventListener('click', () => {
        button.parentNode.classList.add('open-submenu');
        button.nextSibling.classList.add('open-submenu');
        checkSubmenuOpen(button);
      });

      button.nextSibling.querySelector('.back-link .back').addEventListener('click', () => {
        button.parentNode.classList.remove('open-submenu');
        button.nextSibling.classList.remove('open-submenu');
        checkSubmenuOpen();
      });
    });
  }

  const checkSubmenuOpen = (submenuOpen = null) => {
    if (submenuOpen && submenuOpen.parentNode.parentNode.tagName === "UL") {
      submenuOpen.parentNode.parentNode.style.height = submenuOpen.nextSibling.offsetHeight + "px";
      submenuOpen.parentNode.parentNode.style.position = "static";
      submenuOpen.parentNode.parentNode.style.overflow = "hidden";
    } else {
      root.querySelectorAll('ul').forEach(ul => {
        ul.style.removeProperty('height');
        ul.style.removeProperty('position');
        ul.style.removeProperty('overflow');
      })
    }
  }

  const menuComportement = () => {
    menuToggle.addEventListener("click", () => {
      toggleMenu();
    });


    submenuOpen();
    // window.addEventListener("click", (e) => {
    //   if (menuToggle.getAttribute("aria-expanded") === "true") {
    //     if(e.target !== menuToggle) {
    //         toggleMenu();
    //     }

    //   }
    // });
  };

  const init = () => {
    if (menuContainer) {
      createMenu();
      littleStyle();
      menuComportement();
    }
  };

  init();
})(drupalSettings);
